import React, { Component, PropTypes } from 'react';
import { Paper } from 'material-ui';
import { ThemeStore } from 'stores';
import { StoreOverviewActions } from 'actions';
import * as SvgIcons from 'components/Material/SvgIcons';
import Cover from 'components/Material/Cover';
import { FormattedNumber, FormattedMessage } from 'react-intl';
import { Units, Shadow, Colors } from 'Css';
import { TagList } from 'components/Tags';

const css = oxygenCss({
  root: {
    padding: `${Units.base * 2}px 0`
  },

  detail: {
    flexGrow: 1,
    padding: Units.base,
    boxSizing: 'border-box',
    flexGrow: 1
  },
  price: {
    padding: Units.base,
    flexGrow: 0,
    textAlign: 'right',
    fontSize: 14,
    lineHeight: '32px',
    flexGrow: 0
  },
  tags: {
    flexGrow: 0,
    padding: `0 ${Units.base}px`,
    flexGrow: 0
  },
  header: {
    fontSize: 20,
    lineHeight: '32px'
  },
  description: {
    fontSize: 14,
    ' UL': {
      margin: Units.base
    },
    ' OL': {
      margin: Units.base
    }
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'stretch',
    padding: Units.base * 2,
    '@phone': {
      padding: Units.base,
      display: 'block'
    }
  },
  itemWrapper: {
    margin: Units.base,
    position: 'relative',
    boxSizing: 'border-box',
    boxShadow: Shadow[1],
    backgroundColor: Colors.theme.Light.card,
    display: 'flex',
    flexDirection: 'column',
    '@tablet': {
      flex: '0 0 50%'
    },
    '@desktop': {
      flex: '0 0 293px'
    },
    cursor: 'pointer'
  },
  buyButton: {
    cursor: 'pointer',
    borderRadius: 2,
    boxShadow: Shadow[1],
    backgroundColor: '#FF5555',
    position: 'absolute',
    top: Units.base * 1,
    right: Units.base * 1,
    minWidth: 64,
    textAlign: 'center',
    lineHeight: '24px',
    padding: `${Units.base / 2}px ${Units.base}px`,
    color: Colors.fullWhite,
    fontWeight: 500
  },
  giftButton: {
    cursor: 'pointer',
    borderRadius: 2,
    boxShadow: Shadow[1],
    backgroundColor: '#FF55FF',
    position: 'absolute',
    top: Units.base * 1,
    left: Units.base * 1,
    minWidth: 64,
    textAlign: 'center',
    lineHeight: '24px',
    padding: `${Units.base / 2}px ${Units.base}px`,
    color: Colors.fullWhite,
    fontWeight: 500
  },
  packBadge: {
    position: 'absolute',
    top: Units.base * 1,
    left: Units.base,
    lineHeight: '24px',
    padding: `${Units.base / 2}px ${Units.base}px`,
    color: Colors.fullWhite,
    fontWeight: 500,
    '>SVG': {
      verticalAlign: 'middle'
    }
  },
  publicIcon: {
    position: 'absolute',
    bottom: 4,
    left: 4
  }
});

class StoreGrid extends Component {
  static propTypes = {
    username: PropTypes.string,
    items: PropTypes.array,
    canIEdit: PropTypes.bool,
    themeColor: PropTypes.string,
    onTouchTapItem: PropTypes.func,
    cart: PropTypes.array
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  onTouchTap = storeItem => {
    const { onTouchTapItem } = this.props;
    if (onTouchTapItem) {
      onTouchTapItem(storeItem);
    } else {
      const { type, slug } = storeItem;
      StoreOverviewActions.findBySlug(type, slug);
    }
  };

  buyItem = (storeItem, event) => {
    StoreOverviewActions.addToCart(storeItem);
    event.preventDefault();
    event.stopPropagation();
  };

  giftItem = (storeItem, event) => {
    StoreOverviewActions.addToCart(storeItem, true);
    event.preventDefault();
    event.stopPropagation();
  };

  render() {
    const { items, canIEdit, themeColor } = this.props;
    return (
      <div className={css.container}>
        {items.map(storeItem => {
          const {
            price,
            currency,
            type,
            id,
            name,
            public: isPublic
          } = storeItem;
          const coverImages = storeItem.coverImage;
          const coverImage =
            (coverImages.length && coverImages.length > 0 && coverImages[0]) ||
            {};
          return (
            <div
              className={css.itemWrapper}
              key={storeItem.type + '-' + id}
              onTouchTap={this.onTouchTap.bind(this, storeItem)}
            >
              <Cover
                backgroundColor={
                  (!canIEdit && ThemeStore.getColor(themeColor, 0.5)) ||
                  'rgba(0, 0, 0, 0.5)'
                }
                image={coverImage.id && coverImage.url}
              />
              {canIEdit && isPublic ? (
                <div className={css.publicIcon}>
                  <SvgIcons.ImageRemoveRedEye
                    color={'green'}
                    style={{ width: 32, height: 32 }}
                  />
                </div>
              ) : null}
              {type === 2 && (
                <Paper
                  className={css.packBadge}
                  style={{ backgroundColor: ThemeStore.getColor(themeColor) }}
                >
                  <SvgIcons.ActionViewModule color={Colors.fullWhite} />
                  <FormattedMessage
                    message={this.context.getIntlMessage('store.packOf')}
                    count={storeItem.courses.length}
                  />
                </Paper>
              )}
              {isPublic ? (
                <div
                  onTouchTap={this.buyItem.bind(this, storeItem)}
                  className={css.buyButton}
                >
                  {this.context.getIntlMessage('store.joinCourse')}
                </div>
              ) : null}
              {isPublic ? (
                <div
                  onTouchTap={this.giftItem.bind(this, storeItem)}
                  className={css.giftButton}
                >
                  {this.context.getIntlMessage('store.giftCourse')}
                </div>
              ) : null}
              <div className={css.detail}>
                <div className={css.header}>{name}</div>
                <div
                  className={css.description}
                  dangerouslySetInnerHTML={{ __html: storeItem.description }}
                />
              </div>
              <div className={css.tags}>
                <TagList tags={storeItem.tagsMap} />
              </div>
              <div className={css.price}>
                <FormattedNumber
                  style="currency"
                  currency={currency}
                  value={Math.round(price.discounted)}
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default StoreGrid;



// WEBPACK FOOTER //
// ./src/js/components/Store/StoreGrid.js